import React from 'react';
import { connect } from 'react-redux';
import { SERVER_BASE_URL } from '../constants';

import { getPostShareDetails } from '../redux/modules/user/action';
import { parseDateToStringFormat } from '../utils/dateUtils';

class PostShare extends React.Component {
  state = {
    message: null
  };

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(getPostShareDetails(match.params.id));
  }

  showGender = (gender) => {
    if (gender === '3') {
      return 'Any';
    } else if (gender === '2') {
      return 'LGBTQ';
    } else if (gender === '1') {
      return 'Female';
    } else if (gender === '0') {
      return 'Male';
    }
  }

  render() {
    const { sharePostDetails = { userDetail: {} } } = this.props;

    if (!sharePostDetails) {
      return (
        <React.Fragment>
          <header className="menu_logo back">
          <div className="left_logo">
            <img alt="" src="/images/logo.png" />
          </div>
          <div className="right_logo">
          </div>
        </header>
        <div className="container">
        <section className="menu_list">
          <h3>No Details Found</h3>
        </section>
        </div>
        </React.Fragment>
      );
    }

    const name = `${sharePostDetails.userDetail.firstName} ${sharePostDetails.userDetail.lastName}`;
    const profileImage = sharePostDetails.userDetail.image || '';
    const moveInDate = parseDateToStringFormat(sharePostDetails.move_in_date);

    return (
      <React.Fragment>
        <header className="menu_logo back">
          <div className="left_logo">
            <img alt="logo" src="/images/logo.png" />
          </div>
          <div className="right_logo">
            <img alt="" src={`${SERVER_BASE_URL}${profileImage}`} />
            <h3>{name}</h3>
          </div>
        </header>
        <div className="container">
          <section className="menu_list">
            <div className="list_set back">
              <img alt="" src="/images/1.png" />
              <h3>{moveInDate}</h3>
            </div>
            
            <div className="list_set back">
              <img alt="" src="/images/2.png" />
              <h3>{sharePostDetails.alcoholic === '1' ? 'Yes' : ' No'}</h3>
            </div>

            <div className="list_set back">
              <img alt="" src="/images/3.png" />
              <h3>{sharePostDetails.smoker === '1' ? 'Yes' : ' No'}</h3>
            </div>

            <div className="list_set back">
              <img alt="" src="/images/4.png" />
              <h3>{sharePostDetails.pet_friendly === '1' ? 'Yes' : ' No'}</h3>
            </div>

            <div className="list_set back">
              <img alt="" src="/images/5.png" />
              <h3>{sharePostDetails.min_age} - {sharePostDetails.max_age} Yrs</h3>
            </div>

            <div className="list_set back">
              <img alt="" src="/images/6.png" />
              <h3>{sharePostDetails.city}</h3>
            </div>

            <div className="list_set back">
              <img alt="" src="/images/7.png" />
              <h3>{sharePostDetails.roommates}</h3>
            </div>

            {
              sharePostDetails.college && 
              <div className="list_set back">
                <img alt="" src="/images/8.png" />
              <h3>{sharePostDetails.college}</h3>
            </div>
            }
            
            <div className="list_set back">
              <img alt="" src="/images/9.png" />
              <h3>{this.showGender(sharePostDetails.gender)}</h3>
            </div>

            {
              sharePostDetails.property_type && 
              <div className="list_set back">
                <img alt="" src="/images/10.png" />
                <h3>{sharePostDetails.property_type}</h3>
              </div>
            }
            

            <div className="list_set back">
              <img alt="" src="/images/11.png" />
              <h3>{sharePostDetails.friendly === '1' ? 'Yes' : ' No'}</h3>
            </div>

            {
              sharePostDetails.course && 
              <div className="list_set back">
                <img alt="" src="/images/12.png" />
                <h3>{sharePostDetails.course}</h3>
              </div>
            }
            

          </section>
          <section className="menu_play">
            <a href="https://itunes.apple.com/us/app/roomerresume/id1392857337?ls=1&mt=8">
            <img alt="" src="/images/apple.png" />  </a>
            <a href="https://play.google.com/store/apps/details?id=com.roomer_resume"  style={{ marginLeft: '10px' }}>
            <img alt="" src="/images/play.png" />  </a>
          </section>
        </div>
        <footer className="menu_logo back">
          <div className="foter">
            <p> Copyright 2019 © RoomerResume. All Rights Reserved.</p>
          </div>
        </footer>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  sharePostDetails: state.user.sharePostDetails
});

export default connect(mapStateToProps)(PostShare);